import {
  BILLING_CYCLE,
  planTypes,
  billingCycleDependBasePlanTypeList,
  licenseDependBasePlanTypeList,
  PlanModelInfo,
} from '@/common/constants';
import { getCartInfo } from '@/common/service/default-mapper';
import { planUnitMap } from '@/common/product-unit';

const usersLimit = { max: 9999, min: 1 };
const notStandardKeysOfZRA = {
  [BILLING_CYCLE.QUARTERLY]: 'zkw_quarterly',
  [BILLING_CYCLE.TWO_YEARS]: 'zkw_two_years',
  [BILLING_CYCLE.THREE_YEARS]: 'zkw_three_years',
};

const standardKeysOfZRA = {
  [BILLING_CYCLE.ANNUAL]: 'zkw_annual',
  [BILLING_CYCLE.MONTHLY]: 'zkw_monthly',
};

export const ZRAPlanMapKeys = {...notStandardKeysOfZRA, ...standardKeysOfZRA}

function pickInfo(revenueAcceleratorPlan) {
  const result = [];
  Object.keys(ZRAPlanMapKeys).forEach((currentBillingCycle) => {
    const plan = revenueAcceleratorPlan[ZRAPlanMapKeys[currentBillingCycle]];
    if (plan) {
      const { prices, plan_code, plan_type } = plan;
      const formattedPlan = {
        type: planTypes.ZOOM_REVENUE_ACCELERATOR,
        category: 'zm_kiwi',
        sub_type: 'zm_kiwi',
        plan_code: plan_code,
        plan_type,
        amount: prices[0].price,
        prices,
        cartInfo: getCartInfo(),
        billing_cycle: currentBillingCycle,
        typeNameKey: 'billing.planform.title.zoom_revenue_accelerator',
        planNameKey: 'billing.planform.title.zoom_revenue_accelerator',
        supportCoupon: true,
        dependBasePlanTypeList: [],
        billingCycleDependBasePlanTypeList,
        // BUY TRIAL
        // FREE TRIAL
        isOnlineFreeTrial: false,
        trialDays: undefined,
        trialCode: '',
        ...usersLimit,
        licenseDependBasePlanTypeList,
        unit: planUnitMap.license,
        planModel: PlanModelInfo.license
      };

      result.push(formattedPlan);
    }
  });
  return result;
}
export default (planMapJSON) => pickInfo(planMapJSON.zkw_price_list || {});
